import script from "./ApprovalManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalManagement.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalManagement.vue?vue&type=style&index=0&id=0321a2eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0321a2eb"]])

export default __exports__